import { render, staticRenderFns } from "./ParosEnCurso.vue?vue&type=template&id=327c0112&"
import script from "./ParosEnCurso.vue?vue&type=script&lang=js&"
export * from "./ParosEnCurso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports